import countryCodeOptions from '../components/phone-number-input/countryCodes.json';

const detectCountryCode = (value: string) => {
    for (const country of countryCodeOptions) {
        if (value.startsWith(country.dial_code)) {
            return country.dial_code;
        }
    }
    return null;
};

export const validatePhoneNumberWithCountryCode = (phoneNumber: string) => {
    const countryCode = detectCountryCode(phoneNumber);

    if (!countryCode) {
        return false;
    }

    const phoneNumberWithoutPrefix = phoneNumber.replace(countryCode, '');
    const phoneRegex = /^\d{4,11}$/;

    if (
        phoneNumberWithoutPrefix.length &&
        (!phoneRegex.test(phoneNumberWithoutPrefix) || phoneNumberWithoutPrefix.length < 4 || phoneNumberWithoutPrefix.length > 11)
    ) {
        return false;
    }

    return true;
};
